// frontend/src/pages/AppLoader/AppLoader.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDemoUser, getDemoSession } from '../../utils/mockAuth';

export default function AppLoader() {
  const navigate = useNavigate();
  const [loadingText, setLoadingText] = useState('Verificando sesión');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 90) return prev;
        return prev + Math.random() * 15;
      });
    }, 180);

    const fetchUserRole = async () => {
      try {
        setProgress(20);
        setLoadingText('Verificando usuario');

        const session = getDemoSession();

        if (!session) {
          clearInterval(progressInterval);
          navigate('/login', { replace: true });
          return;
        }

        setProgress(40);
        setLoadingText('Cargando perfil');

        const usuario = getDemoUser();

        if (!usuario) {
          clearInterval(progressInterval);
          navigate('/login', { replace: true });
          return;
        }

        setProgress(70);
        setLoadingText(`Hola, ${usuario.nombre.split(' ')[0]}`);

        localStorage.setItem('userId', usuario.id_usuario);
        localStorage.setItem('userName', usuario.nombre);
        localStorage.setItem('userRole', usuario.rol.nombre);
        localStorage.setItem('userRoleId', usuario.rol.id_rol);
        localStorage.setItem('userEmail', usuario.email);
        if (usuario.rut) localStorage.setItem('userRut', usuario.rut);
        if (usuario.estado) localStorage.setItem('userEstado', usuario.estado);
        if (usuario.id_empresa) localStorage.setItem('userEmpresaId', usuario.id_empresa);

        setProgress(90);
        setLoadingText('Preparando dashboard');

        await new Promise(res => setTimeout(res, 500));

        setProgress(100);
        clearInterval(progressInterval);

        if (!usuario.id_empresa) {
          navigate('/app/superadmin/dashboard', { replace: true });
          return;
        }

        switch (usuario.rol.nombre) {
          case 'ADMIN':
            navigate('/app/admin/dashboard', { replace: true });
            break;
          case 'JEFE':
            navigate('/app/jefe/inicio', { replace: true });
            break;
          case 'COLABORADOR':
            navigate('/app/colaborador/dashboard', { replace: true });
            break;
          default:
            navigate('/login', { replace: true });
        }
      } catch (error) {
        clearInterval(progressInterval);
        navigate('/login', { replace: true });
      }
    };

    fetchUserRole();

    return () => clearInterval(progressInterval);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6 relative overflow-hidden font-sans">
      {/* Background Glow Overlay */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/15 rounded-full blur-3xl"></div>
        <div className="absolute top-1/3 left-1/3 w-64 h-64 bg-emerald-500/10 rounded-full blur-2xl"></div>
      </div>

      <div className="relative z-10 w-full max-w-sm text-center bg-slate-900/60 backdrop-blur-xl border border-slate-800/80 rounded-3xl p-8 shadow-2xl">
        {/* Brand Icon */}
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold text-white tracking-tight">
            CommitFlow
          </h1>
          <p className="text-slate-400 text-xs mt-1">Gestión de Proyectos & Colaboradores</p>
        </div>

        {/* Animated Dots */}
        <div className="flex justify-center gap-2 mb-6">
          <span className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></span>
          <span className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-pulse" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2.5 h-2.5 bg-indigo-500 rounded-full animate-pulse" style={{ animationDelay: '300ms' }}></span>
        </div>

        {/* Dynamic Status Text */}
        <p className="text-white font-semibold text-base mb-1">
          {loadingText}
        </p>
        <p className="text-slate-400 text-xs mb-6">
          Sincronizando información...
        </p>

        {/* Progress Bar Container */}
        <div className="w-full max-w-xs mx-auto mb-8">
          <div className="h-2 bg-slate-800 rounded-full overflow-hidden p-0.5 border border-slate-700/50">
            <div
              className="h-full bg-gradient-to-r from-blue-500 via-indigo-500 to-emerald-400 rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        {/* Standalone Demo Badge */}
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 bg-slate-800/80 border border-slate-700/60 rounded-full">
            <span className="h-2 w-2 rounded-full bg-emerald-400 animate-ping"></span>
            <span className="text-slate-300 text-xs font-medium">Modo Demo Activo</span>
          </span>
        </div>
      </div>
    </div>
  );
}